import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {EvkExpedienteModel} from '../../../../../../expediente/models/evk-expediente.model';
import * as _ from 'lodash';
import {EvkExpedienteConfigModel} from '../../../../../../expediente/models/evk-expediente-config.model';
import { MatDialog } from "@angular/material/dialog";
import { ExpedienteUpdateService } from '../../../../../../expediente/services/expediente-update.service';
import { MessageCrudService } from '@evomatik/evk-common';
import {FormGroup} from "@angular/forms";


@Component({
    selector: 'lib-expediente-detalle',
    templateUrl: './expedientes-detalle.component.html',
    styleUrls: ['./expedientes-detalle.component.css'],
    providers: [ExpedienteUpdateService],
    encapsulation: ViewEncapsulation.None

})
export class ExpedientesDetalleComponent implements OnInit {
    @Input()
    expediente: EvkExpedienteModel;

    @Input()
    expedienteConfig: EvkExpedienteConfigModel;

    @Input() readOnlyForm = true;

    @Input() form: FormGroup = new FormGroup({});

    constructor(
        public dialog: MatDialog,
        public messageCrudService: MessageCrudService,
) {
    }

    findSeccion(nombre) {
        if (this.expediente && this.expediente.secciones && this.expediente.secciones.length > 0) {
            return _.get(this.expediente.secciones.find(seccion => seccion.origen === nombre), 'propiedades', '');
        }
        return null;
    }

    ngOnInit(): void {
    }


}
